__turbopack_context__.v({
  "controls": "CoreCarousel-module-scss-module__5DhReG__controls",
  "controls-wrapper": "CoreCarousel-module-scss-module__5DhReG__controls-wrapper",
  "main": "CoreCarousel-module-scss-module__5DhReG__main",
  "navigation-buttons": "CoreCarousel-module-scss-module__5DhReG__navigation-buttons",
  "next": "CoreCarousel-module-scss-module__5DhReG__next",
  "next-icon": "CoreCarousel-module-scss-module__5DhReG__next-icon",
  "page": "CoreCarousel-module-scss-module__5DhReG__page",
  "page--active": "CoreCarousel-module-scss-module__5DhReG__page--active",
  "pagination": "CoreCarousel-module-scss-module__5DhReG__pagination",
  "pagination-controls": "CoreCarousel-module-scss-module__5DhReG__pagination-controls",
  "pause": "CoreCarousel-module-scss-module__5DhReG__pause",
  "pause-play-button": "CoreCarousel-module-scss-module__5DhReG__pause-play-button",
  "play": "CoreCarousel-module-scss-module__5DhReG__play",
  "prev": "CoreCarousel-module-scss-module__5DhReG__prev",
});
